import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
interface HeaderProps {
  onRequestQuote: () => void;
}
export function Header({
  onRequestQuote
}: HeaderProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const {
    t,
    lang,
    setLang
  } = useTranslation();
  const navigation = [{
    name: t.nav.home,
    href: '/'
  }, {
    name: t.nav.products,
    href: '/products'
  }, {
    name: t.nav.applications,
    href: '/applications'
  }, {
    name: t.nav.servis,
    href: '/servis'
  }, {
    name: t.nav.about,
    href: '/about'
  }, {
    name: t.nav.contact,
    href: '/contact'
  }];
  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };
  return <header className="sticky top-0 z-40 bg-dark-bg border-b-2 border-dark-border" data-id="element-323">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" aria-label="Glavna navigacija" data-id="element-324">
        <div className="flex items-center justify-between h-20" data-id="element-325">
          {/* Logo */}
          <Link to="/" className="flex items-center focus:outline-none focus:ring-2 focus:ring-brand-yellow rounded-industrial" data-id="element-326">
            <img src="https://cdn.magicpatterns.com/uploads/wGduMkj3cFFyWsuhxML9qE/LOGO_1.jpg" alt="D-TECH Solutions" className="h-12 sm:h-14 w-auto" data-id="element-327" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-328">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`text-sm font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-brand-yellow rounded-industrial px-2 py-1 ${isActive(item.href) ? 'text-brand-yellow' : 'text-gray-300 hover:text-white'}`} data-id="element-329">
                {item.name}
              </Link>)}

            {/* Language switcher - hidden for now */}
            {/* <div className="flex items-center border border-dark-border rounded-industrial overflow-hidden text-xs font-bold">
             <button
             onClick={() => setLang('sr')}
             className={`px-3 py-2 transition-colors ${lang === 'sr' ? 'bg-brand-yellow text-dark-bg' : 'text-gray-400 hover:text-white'}`}
             >
             SR
             </button>
             <button
             onClick={() => setLang('en')}
             className={`px-3 py-2 transition-colors ${lang === 'en' ? 'bg-brand-yellow text-dark-bg' : 'text-gray-400 hover:text-white'}`}
             >
             EN
             </button>
             </div> */}

            <Button variant="primary" size="sm" onClick={onRequestQuote} data-id="element-330">
              {t.nav.requestQuote}
            </Button>
          </div>

          {/* Mobile: lang switcher + hamburger */}
          <div className="md:hidden flex items-center gap-3" data-id="element-331">
            {/* Mobile lang switcher - hidden for now */}
            {/* <div className="flex items-center border border-dark-border rounded-industrial overflow-hidden text-xs font-bold">
             <button
             onClick={() => setLang('sr')}
             className={`px-2 py-1.5 transition-colors ${lang === 'sr' ? 'bg-brand-yellow text-dark-bg' : 'text-gray-400'}`}
             >
             SR
             </button>
             <button
             onClick={() => setLang('en')}
             className={`px-2 py-1.5 transition-colors ${lang === 'en' ? 'bg-brand-yellow text-dark-bg' : 'text-gray-400'}`}
             >
             EN
             </button>
             </div> */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2 text-white hover:text-brand-yellow transition-colors focus:outline-none focus:ring-2 focus:ring-brand-yellow rounded-industrial" aria-label="Otvori meni" aria-expanded={mobileMenuOpen} data-id="element-332">
              {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-333" /> : <MenuIcon className="w-6 h-6" data-id="element-334" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="md:hidden py-4 border-t-2 border-dark-border" data-id="element-335">
            <div className="flex flex-col space-y-4" data-id="element-336">
              {navigation.map(item => <Link key={item.name} to={item.href} onClick={() => setMobileMenuOpen(false)} className={`text-base font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-brand-yellow rounded-industrial px-2 py-2 ${isActive(item.href) ? 'text-brand-yellow' : 'text-gray-300 hover:text-white'}`} data-id="element-337">
                  {item.name}
                </Link>)}
              <Button variant="primary" size="md" onClick={() => {
            setMobileMenuOpen(false);
            onRequestQuote();
          }} className="w-full" data-id="element-338">
                {t.nav.requestQuote}
              </Button>
            </div>
          </div>}
      </nav>
    </header>;
}